import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { REPORT_DETAILS_MAX_LENGTH, REPORT_REASONS } from "../../utils/moderation";

// "Zgłoś": report another member to the studio. `onSubmit(reason, details)`
// sends it and throws on failure; the parent then offers to block.
const ReportDialog = ({ person, onClose, onSubmit }) => {
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setReason("");
    setDetails("");
    setError(null);
    setSending(false);
  }, [person]);

  const send = async () => {
    if (!reason) {
      setError("Wybierz powód zgłoszenia");
      return;
    }
    setSending(true);
    setError(null);
    try {
      await onSubmit(reason, details.trim() || null);
    } catch (err) {
      setError(err.message);
      setSending(false);
    }
  };

  return (
    <Dialog open={Boolean(person)} onClose={onClose} fullWidth maxWidth="sm" data-testid="report-dialog">
      {person && (
        <>
          <DialogTitle>Zgłoś {person.full_name}</DialogTitle>
          <DialogContent>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Zgłoszenie trafi do studia, a {person.full_name} się o nim nie dowie.
            </Typography>
            <RadioGroup value={reason} onChange={(e) => setReason(e.target.value)}>
              {REPORT_REASONS.map((r) => (
                <FormControlLabel key={r.value} value={r.value} control={<Radio size="small" />} label={r.label} />
              ))}
            </RadioGroup>
            <TextField
              label="Opis (opcjonalnie)"
              placeholder="Co się stało?"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              inputProps={{ maxLength: REPORT_DETAILS_MAX_LENGTH }}
              multiline
              minRows={3}
              fullWidth
              sx={{ mt: 1 }}
            />
            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error}
              </Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} disabled={sending}>
              Anuluj
            </Button>
            <Button variant="contained" color="error" onClick={send} disabled={sending}>
              Wyślij zgłoszenie
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default ReportDialog;
